'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonLink } from '@kiao-voice/ui-kit'
import { InkHero } from '../../components/site/ink-hero'
import { ANALYTICS_EVENTS, trackEvent } from '../../lib/analytics'
import { smoothScrollToAnchor } from '../../lib/smooth-scroll'

/**
 * 語音輸入頁首屏。標題只有兩個片語，文字欄收窄到 34em，墨才不會被推到畫面外。
 * 主鈕是品牌紅——這是本頁唯一一顆紅實心焦點。
 */
export function DictationHero() {
  const { t } = useTranslation(['web'])

  return (
    <InkHero
      eyebrow={t('web:dictationPage.hero.eyebrow')}
      titleKey="web:dictationPage.hero.title"
      lead={t('web:dictationPage.hero.lead')}
      copyWidth="narrow"
      titleLeading="roomy"
      meta={t('web:dictationPage.hero.meta')}
      actions={
        <>
          <ButtonLink
            variant="brand"
            size="marketing"
            href="#download"
            onClick={(event) => {
              trackEvent(ANALYTICS_EVENTS.landingDownloadCtaClick, { location: 'hero' })
              smoothScrollToAnchor(event)
            }}
          >
            {t('web:dictationPage.hero.primaryCta')}
          </ButtonLink>
          <ButtonLink
            variant="secondary"
            size="marketing"
            href="#demo"
            onClick={(event) => {
              trackEvent(ANALYTICS_EVENTS.landingTryDemoClick, { location: 'hero' })
              smoothScrollToAnchor(event)
            }}
          >
            {t('web:dictationPage.hero.secondaryCta')}
          </ButtonLink>
        </>
      }
    />
  )
}
